<template>
  <div
    :key="$route.fullPath"
    class="wrap"
  >
    <div
      v-if="!loaded"
      class="wrap--loading"
    />

    <div
      v-else
      key="PDF"
    >
      <div class="pdf">
        <LayoutResourceHeader
          :title="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.title ? results.pdf.byId[selectedHash].attributes.title : 'Unknown'"
          type="pdfs"
          logo='<svg xmlns="http://www.w3.org/2000/svg" height="100%" width="100%" viewBox="0 0 24 24"><path d="M8.847 17.875c.191-.211.548-.431.801-.559-.152.3-.366.619-.544.792-.36.353-.556.095-.257-.233zm7.062-12.098c2.047-.478 4.805.28 6.091 1.179-1.494-1.997-5.23-5.708-7.432-6.882 1.156 1.168 1.563 4.235 1.341 5.703zm-4.769 10.21c.328-.109 1.036-.274 1.213-.315-.02-.021-.528-.544-.695-.832-.134.335-.509 1.127-.518 1.147zm.64-4.008c-.057-.278-.263-.299-.326.024-.057.296.029.771.129 1.061.113-.237.255-.805.197-1.085zm10.22-.979v13h-20v-24h8.409c4.857 0 3.335 8 3.335 8 3.009-.745 8.256-.42 8.256 3zm-6.98 4.413c-.526-.077-1.272.009-1.797.093-.385-.325-.866-.817-1.233-1.472.253-.652.415-1.168.483-1.536.354-1.919-1.979-2.072-1.729-.012.066.549.222 1.082.464 1.588-.286.709-.651 1.508-1.018 2.232-.811.307-1.396.627-1.742.954-1.212 1.143.295 2.661 1.438 1.014.274-.395.581-.955.811-1.396.717-.253 1.551-.475 2.33-.618.509.39 1.322.896 1.972.896 1.239.001 1.417-1.538.021-1.743zm-.104.704c-.2-.03-.488-.03-.829-.002.235.158.558.323.911.33.412.008.377-.26-.082-.328z"/></svg>'
          :topics="[results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.topics[0] ? results.pdf.byId[selectedHash].attributes.topics[0].id : '']"
          :resourceId="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].id ? results.pdf.byId[selectedHash].id : '#'"
          :licensed="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.licensed === true && results.pdf.byId[selectedHash].attributes.trial === false ? true : false"
          :trial="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.trial === true && results.pdf.byId[selectedHash].attributes.trial === false ? true : false"
          :free="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.free === true && results.pdf.byId[selectedHash].attributes.free === false ? true : false"
          :filterWords="filterWords"
          :comingFrom="comingFrom"
        />

        <div class="pdf__content">
          <div class="pdf__download">
            <p
              v-if="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.licensed === true && results.pdf.byId[selectedHash].attributes.trial === false"
              style="margin: 8px 0 0 0;"
            />

            <p v-else>You need active subscription to download market reports.<br />If have already subscribed <router-link to="/login" class="link">click here</router-link> to login.</p>

            <FormSubmit
              :status="downloadStatus"
              :disabled="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.licensed === true && results.pdf.byId[selectedHash].attributes.trial === false ? false : true"
              icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M9 3h6v2h-6v-2zm3 15l7-8h-4v-4h-6v4h-4l7 8zm3-16v-2h-6v2h6zm3.213-.246l-1.213 1.599c2.984 1.732 5 4.955 5 8.647 0 5.514-4.486 10-10 10s-10-4.486-10-10c0-3.692 2.016-6.915 5-8.647l-1.213-1.599c-3.465 2.103-5.787 5.897-5.787 10.246 0 6.627 5.373 12 12 12s12-5.373 12-12c0-4.349-2.322-8.143-5.787-10.246z"/></svg>'
              @click="downloadPDF()"
            >
              {{ downloadStatus === 'success' ? 'Thank you!' : 'Download PDF' }}
            </FormSubmit>
          </div>

          <UtilityAccordion title="Info">
            <div class="info">
              <div class="info__item" title="Topic">
                <div class="info__icon info__icon--blue">
                  <svg xmlns="http://www.w3.org/2000/svg" height="100%" width="100%" viewBox="0 0 24 24"><path d="M20 9.352c0-4.852-4.75-8.352-10-8.352-5.281 0-10 3.527-10 8.352 0 1.71.615 3.39 1.705 4.695.047 1.527-.85 3.719-1.66 5.312 2.168-.391 5.252-1.258 6.648-2.115 7.698 1.877 13.307-2.842 13.307-7.892zm-14.5 1.381c-.689 0-1.25-.56-1.25-1.25s.561-1.25 1.25-1.25 1.25.56 1.25 1.25-.561 1.25-1.25 1.25zm4.5 0c-.689 0-1.25-.56-1.25-1.25s.561-1.25 1.25-1.25 1.25.56 1.25 1.25-.561 1.25-1.25 1.25zm4.5 0c-.689 0-1.25-.56-1.25-1.25s.561-1.25 1.25-1.25 1.25.56 1.25 1.25-.561 1.25-1.25 1.25zm7.036 1.441c-.161.488-.361.961-.601 1.416 1.677 1.262 2.257 3.226.464 5.365-.021.745-.049 1.049.138 1.865-.892-.307-.979-.392-1.665-.813-2.127.519-4.265.696-6.089-.855-.562.159-1.145.278-1.74.364 1.513 1.877 4.298 2.897 7.577 2.1.914.561 2.933 1.127 4.352 1.385-.53-1.045-1.117-2.479-1.088-3.479 1.755-2.098 1.543-5.436-1.348-7.348z"></path></svg>
                </div>
                <div class="info__title">Topic</div>
                <div class="info__content">
                  <router-link
                    v-if="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.topics.length > 0"
                    :to="'/pdfs?topics=' + results.pdf.byId[selectedHash].attributes.topics[0].id + '&page=1&sort=relevance'"
                    class="link link--blue_alt"
                    v-html="results.pdf.byId[selectedHash].attributes.topics[0].attributes.name"
                  />
                  <span v-else>-</span>
                </div>
              </div>

              <div class="info__item" title="Location">
                <div class="info__icon info__icon--green">
                  <svg xmlns="http://www.w3.org/2000/svg" height="100%" width="100%" viewBox="0 0 24 24"><path d="M11.239 7.237c-.004-.009-.288-.017-.24-.078l.137-.085c.013-.077.072-.162-.007-.304l.047-.125-.1.029s.141-.606.33-.332l-.08.093c.122.122.155.426.195.623.115.06.294.071.088.175.106-.018-.561.286-.648.161-.065-.076.288-.127.278-.157zm-.715-.159c-.077.078.003.128.082.094.114-.05.269-.048.284-.202l.073-.091-.101-.135c-.06-.012-.1.064-.137.095l-.066.017-.062.08.007.044-.08.098zm7 9.167l-.733-1.206-.724-1.186c-.73-1.194-1.388-2.276-1.961-3.296l-.07.067c-.376.156-.942-.509-1.339-.531.192.03.018-.49.018-.524-.153-.189-1.123.021-1.378.055-.479.063-.979.057-1.346.355-.258.21-.262.551-.524.716-.17.106-.356.072-.502.209-.258.245-.553.607-.697.929-.062.135.077.458.043.632-.336 1.063.085 2.538 1.375 2.701.312.039.638.209.955.114.252-.076.474-.248.745-.268.377-.025.22.529.737.379.251-.074.365.172.365.359-.084.391-.268.609.088.883.242.188.442.456.486.78.026.182.196.494-.015.602-.149.075-.259.507-.257.649.031.165.365.481.466.621.146.2.039.436.158.663.122.232.237.41.323.645.111.324.958-.007 1.156-.006.673.004 1.014-.944 1.487-1.235.267-.165.192-.616.51-.848.296-.215.608-.344.636-.741.021-.344-.259-1.062-.104-1.353l.102-.165zm-7.301-7.76c.041.172-.119.645-.154.795-.031.138.442.226.415.295.004-.008.642-.22.705-.275l.144-.323c.121-.081.248-.146.384-.196l.164-.285c.056-.021.71-.123.756-.101.165.075.469.389.583.531l.041.032c-.326-.67-.59-1.314-.796-1.942l-.083.036c-.222 0-.528.251-.663.405-.095.104-.669.337-.732.33.33.035.314.276.288.482-.068.476-1.096.035-1.052.216zm10.904 5.049c-.277 4.807-4.253 8.623-9.13 8.623-2.603 0-4.951-1.086-6.618-2.83-.198-.208-.346-.7-.02-.9l.331-.085c.259-.22-.242-1.111-.044-1.254.617-.441.324-.982-.055-1.429-.161-.19-1.043-1.1-1.143-.937.074-.249-.16-.85-.302-1.087-.239-.398-.553-.643-.679-1.081-.05-.174-.05-.704-.153-.826-.041-.05-.358-.185-.347-.257.305-1.82 1.147-3.458 2.364-4.751l.821-.33c.515-.773.545-.173 1.008-.375.154 0 .331-.634.496-.734.289-.185.068-.185.015-.27-.112-.184 2.411-1.103 2.453-.938.034.14-1.249.809-1.108.788-.326.043-.388.627-.328.625.163-.005 1.182-.774 1.657-.61.466.161 1.301-.37 1.627-.64l.04-.038c.029-.761.195-1.494.481-2.172l-.493-.026c-6.075 0-11 4.925-11 11s4.925 11 11 11c6.074 0 11-4.925 11-11 0-.764-.078-1.509-.227-2.229-.491.864-1.044 1.779-1.646 2.763zm1.873-9.1c0 2.45-1.951 5.373-4.5 9.566-2.549-4.193-4.5-7.116-4.5-9.566 0-2.449 2.139-4.434 4.5-4.434s4.5 1.985 4.5 4.434zm-2.75.066c0-.966-.784-1.75-1.75-1.75s-1.75.784-1.75 1.75.784 1.75 1.75 1.75 1.75-.784 1.75-1.75z"></path></svg>
                </div>
                <div class="info__title">Location</div>
                <div class="info__content">
                  <router-link
                    v-if="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.locations.length > 0"
                    :to="'/pdfs?locations=' + results.pdf.byId[selectedHash].attributes.locations[0].id + '&page=1&sort=relevance'"
                    class="link link--green_alt"
                    v-html="results.pdf.byId[selectedHash].attributes.locations[0].attributes.name"
                  />
                  <span v-else>-</span>
                </div>
              </div>

              <div class="info__item" title="Data Provider">
                <div class="info__icon info__icon--pink">
                  <svg xmlns="http://www.w3.org/2000/svg" height="100%" width="100%" viewBox="0 0 24 24" fill-rule="evenodd" clip-rule="evenodd"><path d="M24 11.374c0 4.55-3.783 6.96-7.146 6.796-.151 1.448.061 2.642.384 3.641l-3.72 1.189c-.338-1.129-.993-3.822-2.752-5.279-2.728.802-4.969-.646-5.784-2.627-2.833.046-4.982-1.836-4.982-4.553 0-4.199 4.604-9.541 11.99-9.541 7.532 0 12.01 5.377 12.01 10.374zm-21.992-1.069c-.145 2.352 2.179 3.07 4.44 2.826.336 2.429 2.806 3.279 4.652 2.396 1.551.74 2.747 2.37 3.729 4.967l.002.006.111-.036c-.219-1.579-.09-3.324.36-4.528 3.907.686 6.849-1.153 6.69-4.828-.166-3.829-3.657-8.011-9.843-8.109-6.302-.041-9.957 4.255-10.141 7.306zm8.165-2.484c-.692-.314-1.173-1.012-1.173-1.821 0-1.104.896-2 2-2s2 .896 2 2c0 .26-.05.509-.141.738 1.215.911 2.405 1.855 3.6 2.794.424-.333.96-.532 1.541-.532 1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5c-1.171 0-2.155-.807-2.426-1.895-1.201.098-2.404.173-3.606.254-.17.933-.987 1.641-1.968 1.641-1.104 0-2-.896-2-2 0-1.033.784-1.884 1.79-1.989.12-.731.252-1.46.383-2.19zm2.059-.246c-.296.232-.66.383-1.057.417l-.363 2.18c.504.224.898.651 1.079 1.177l3.648-.289c.047-.267.137-.519.262-.749l-3.569-2.736z"></path></svg>
                </div>
                <div class="info__title">Data Provider</div>
                <div class="info__content">
                  <router-link
                    v-if="results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.providers.length > 0"
                    :to="'/pdfs?providers=' + results.pdf.byId[selectedHash].attributes.providers[0].id + '&page=1&sort=relevance'"
                    class="link link--pink_alt"
                    v-html="results.pdf.byId[selectedHash].attributes.providers[0].attributes.name"
                  />
                  <span v-else>-</span>
                </div>
              </div>

              <div class="info__item" title="Published">
                <div class="info__icon info__icon--white">
                  <svg xmlns="http://www.w3.org/2000/svg" height="100%" width="100%" viewBox="0 0 24 24"><path d="M17 3v-2c0-.552.447-1 1-1s1 .448 1 1v2c0 .552-.447 1-1 1s-1-.448-1-1zm-12 1c.553 0 1-.448 1-1v-2c0-.552-.447-1-1-1-.553 0-1 .448-1 1v2c0 .552.447 1 1 1zm13 13v-3h-1v4h3v-1h-2zm-5 .5c0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5-4.5 2.019-4.5 4.5zm11 0c0 3.59-2.91 6.5-6.5 6.5s-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5zm-14.237 3.5h-7.763v-13h19v1.763c.727.33 1.399.757 2 1.268v-9.031h-3v1c0 1.316-1.278 2.339-2.658 1.894-.831-.268-1.342-1.111-1.342-1.984v-.91h-9v1c0 1.316-1.278 2.339-2.658 1.894-.831-.268-1.342-1.111-1.342-1.984v-.91h-3v21h11.031c-.511-.601-.938-1.273-1.268-2z"/></svg>
                </div>
                <div class="info__title">Published</div>
                <div class="info__content">{{ new Date(results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.created_at).toUTCString() }}</div>
              </div>
            </div>
          </UtilityAccordion>

          <UtilityAccordion title="Metadata">
            <div class="pdf__metadata slider" v-html="formatMeta(results && results.pdf && results.pdf.byId[selectedHash] && results.pdf.byId[selectedHash].attributes.meta ? results.pdf.byId[selectedHash].attributes.meta : false)" />
          </UtilityAccordion>
        </div>

        <div class="pdf__meta">
          <!--<UtilityAccordion
            title="Related"
            noPadding
            :closeInit="!initOpen"
            style="border-top: none;"
          >-->
            <AppDatasets
              key="PDF_DATASETS"
              sliderName="pdf_datasets"
              :title="windowWidth < 640 ? 'Datasets' : 'Related datasets'"
              display="slider"
              :results="results.pdfDatasets"
              :paginator="meta.pdfDatasets.paginator"
              :loading="loading.pdfDatasets"
              :timeout="timeout.pdfDatasets"
              :noResults="noResults.pdfDatasets"
              @itemClicked="itemClicked"
              @controlsChanged="toggleControls"
            />

            <AppPDFs
              key="PDF_PDFS"
              sliderName="pdf_reports"
              :title="windowWidth < 640 ? 'Reports' : 'Related reports'"
              display="slider"
              :selectedResultId="selectedId"
              :results="results.pdfPdfs"
              :paginator="meta.pdfPdfs.paginator"
              :loading="loading.pdfPdfs"
              :timeout="timeout.pdfPdfs"
              :noResults="noResults.pdfPdfs"
              @itemClicked="itemClicked"
              @controlsChanged="toggleControls"
            />
          <!--</UtilityAccordion>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { downloadPost } from '@/helpers/http'
import AppDatasets from '@/components/app/Datasets.vue'
import AppPDFs from '@/components/app/PDFs.vue'
import FormSubmit from '@/components/form/Submit.vue'
import LayoutResourceHeader from '@/components/layout/ResourceHeader.vue'
import UtilityAccordion from '@/components/utility/Accordion.vue'
import UtilityIconButton from '@/components/utility/IconButton.vue'
import helperMethods from '@/helpers/utility.js'

export default {
  components: {
    AppDatasets,
    AppPDFs,
    FormSubmit,
    LayoutResourceHeader,
    UtilityAccordion,
    UtilityIconButton
  },
  metaInfo () {
    if (this.results && this.results.pdf && this.results.pdf.byId[this.selectedHash] && this.results.pdf.byId[this.selectedHash].attributes) {
      return {
        title: this.results.pdf.byId[this.selectedHash].attributes.title,
        meta: [
          {
            name: 'description',
            content: '' // Not available anymore, redo these
          }
        ]
      }
    }
    return {}
  },
  data () {
    return {
      windowWidth: window.innerWidth,
      loaded: false,
      loading: {
        pdfDatasets: true,
        pdfPdfs: true
      },
      timeout: {
        pdfDatasets: false,
        pdfPdfs: false
      },
      noResults: {
        pdfDatasets: false,
        pdfPdfs: false
      },
      url: {
        pdfDatasets: false,
        pdfPdfs: false
      },
      comingFrom: false,
      downloadStatus: 'default',
      panelSuccess: false
    }
  },
  computed: {
    /*initOpen () {
      return this.$store.getters['app/getInitOpen']
    },*/
    selectedHash () {
      return this.$store.getters['search/getSelectedHash']
    },
    selectedId () {
      return this.$store.getters['search/getSelectedId']
    },
    results () {
      return this.$store.getters['search/getResults']
    },
    searchToken () {
      return this.$store.getters['search/getSearchToken']
    },
    input () {
      return this.$store.getters['search/getInput']
    },
    filterAmounts () {
      return this.$store.getters['app/getFilterAmounts']
    },
    meta () {
      return this.$store.getters['search/getMeta']
    },
    filterWords () {
      let words = []
      let getter = this.$store.getters['search/getSelectedFilters']
      Object.keys(getter).forEach(function (filters) {
        if (getter[filters] && getter[filters].length > 0) {
          getter[filters].forEach(function (filter) {
            words.push(filter.attributes.name)
          })
        }
      })
      return words
    },
    isAuthenticated () {
      return this.$store.getters['user/isAuthenticated']
    },
    panelView: {
      get () {
        if (this.isAuthenticated) {
          return false
        }

        if (this.$store.getters['app/getAuthPanelView'] === 'account') {
          return false
        }
        return this.$store.getters['app/getAuthPanelView']
      },
      set (value) {
        this.$store.commit('app/setAuthPanelView', value)
      }
    }
  },
  methods: {
    search (type, view, url) {
      this.$store.dispatch('search/setSearchToken', { 'type': view, 'url': url })
      url = url + 'search_token=' + this.searchToken[view]

      if (!this.results[type] || this.searchToken[view] !== this.meta[type].parameters.search_token) {
        this.$store.dispatch('search/fetchResults', { 'type': type, 'view': view, 'url': url, preventGa: true }).then(response => {
          let checkResults = this.results[type]
          this.loading[type] = false

          if (checkResults.allIds.length === 0) {
            this.noResults[type] = true
            this.timeout[type] = false
          } else {
            this.noResults[type] = false
            this.timeout[type] = false
          }

          return true
        }).catch(error => {
          this.timeout[type] = true
          this.loading[type] = false
        })
      } else {
        this.noResults[type] = false
        this.timeout[type] = false
        this.loading[type] = false
      }

      return false
    },
    downloadPDF () {
      this.downloadStatus = 'loading'
      let parameters = {
        pdfs: [this.selectedId]
      }

      downloadPost('downloads/pdf', parameters).then(response => {
        let blob = new Blob([response.data])
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        let fileName = this.results.pdf.byId[this.selectedHash].attributes.title + '.pdf'
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        this.sendGoogleAnalyticsEvent('download_pdfs_file', this.$store.getters['search/getResults'].pdf.byId[this.$store.getters['search/getSelectedHash']].attributes.title, false, this.$store.getters['user/getSubscriptionStatus'])
        this.downloadStatus = 'success'
      }).catch(error => {
        this.excelError = error.errors
        this.downloadStatus = 'default'
      })
    },
    close () {
      //this.$store.commit('app/setInitOpen', true)
      let searchView = this.comingFrom === 'PDFs' ? 'pdfs' : 'search'

      this.unselectedImageLabels = []
      this.$store.dispatch('app/setSettings', { 'name': 'search.view', 'value': searchView })

      if (searchView === 'search') {
        this.$router.push('/search?' + this.$store.getters['search/getFiltersQuery'](false, false))
      } else {
        this.$router.push('/pdfs?' + this.$store.getters['search/getFiltersQuery'](false, false) + this.$store.getters['search/getControlsQuery']('pdfs', 'client'))
      }
    },
    formatMeta (content) {
      if (content !== false) {
        let result = []

        for (const [key, value] of Object.entries(JSON.parse(content))) {
          let title = key === 'Publish date' ? 'Report\'s original publish date' : key
          result.push('<p><span class="text--bold">' + title + '</span><br />' + this.links(value) + '</p>')
        }

        return result.join('')
      }

      return content
    },
    forwardTo (location) {
      if (location === 'https://statzon.com/contact-us') {
        window.open(location, '_blank')
      } else {
        this.$router.push(location)
      }
    },
    itemClicked (value) {
      if (value.type !== 'news') {
        this.$store.dispatch('search/setSelectedView', value.type)
        this.$store.dispatch('search/setSelectedId', value.id)
        this.$store.dispatch('search/setSelectedHash', value.hash)
        this.$router.push('/'+ value.type + '/' + value.id)
      }
    },
    toggleControls (setting, value) {
      if (setting !== 'pdf.download') {
        this.$store.dispatch('app/setSettings', { 'name': setting, 'value': value })
      }

      if (setting === 'pdf.download') {
        if (value === 'xls') {
          this.downloadExcel()
        } else if (value === 'img') {
          this.downloadImage()
        }
      }

      if (setting === 'search.view') {
        if (['datasets', 'pdfs'].includes(value)) {
          let clonedResults = Object.assign({}, this.results)
          let clonedMeta = Object.assign({}, this.meta)
          let validFilters = ['queries', 'topics', 'locations', 'trade_types', 'scales', 'providers']
          let rawFilters = []
          let setFilters = {}

          for (const filter of validFilters) {
            if (this.meta['pdf' + value.charAt(0).toUpperCase() + value.slice(1)].parameters[filter].length > 0) {
              rawFilters[filter] = this.meta['pdf' + value.charAt(0).toUpperCase() + value.slice(1)].parameters[filter]
            } else {
              rawFilters[filter] = []
            }

            Object.assign(setFilters, { [filter]: rawFilters[filter] })
          }

          clonedResults[value] = clonedResults['pdf' + value.charAt(0).toUpperCase() + value.slice(1)]
          clonedMeta[value] = clonedMeta['pdf' + value.charAt(0).toUpperCase() + value.slice(1)]

          this.$store.dispatch('app/setSettings', { 'name': 'datasets.access', 'value': 'all' }) // TODO: Create app/resetState|Settings function?
          this.$store.dispatch('app/setSettings', { 'name': 'datasets.sort', 'value': 'relevance' })
          this.$store.dispatch('app/setSettings', { 'name': 'pdfs.access', 'value': 'all' })
          this.$store.dispatch('app/setSettings', { 'name': 'pdfs.sort', 'value': 'relevance' })
          this.$store.dispatch('app/setSettings', { 'name': 'news.access', 'value': 'all' })
          this.$store.dispatch('app/setSettings', { 'name': 'news.sort', 'value': 'relevance' })
          this.$store.dispatch('search/setPageNumber', { type: value, value: 1 })
          this.$store.dispatch('search/setResults', clonedResults)
          this.$store.dispatch('search/setFirstResults', clonedResults)
          this.$store.dispatch('search/setSelectedFilters', setFilters)
          this.$store.dispatch('search/setMeta', clonedMeta)
          this.$store.dispatch('search/setPrefetched', true)

          this.$router.push('/' + value + '?' + this.url['pdf' + value.charAt(0).toUpperCase() + value.slice(1)] + this.$store.getters['search/getControlsQuery'](value, 'client'))
        }
      }
    },
    resetResults () {
      let resetResults = this.$store.getters['search/getResults']
      delete resetResults.pdfDatasets
      delete resetResults.pdfPdfs

      this.loading = {
        pdfDatasets: true,
        pdfPdfs: true
      }

      this.$store.dispatch('search/setResults', resetResults)
    },
    async init () {
      let pdfId = this.$route.params.id
      let pdfHash = 'PDF_' + pdfId

      this.$store.dispatch('app/setSettings', { 'name': 'search.view', 'value': 'pdf' })
      this.$store.dispatch('search/setSelectedId', pdfId)
      this.$store.dispatch('search/setSelectedHash', pdfHash)
      this.$store.dispatch('search/setSelectedView', 'pdf')
      this.$store.dispatch('search/logView', pdfHash)

      if(!(this.results && this.results.pdf && this.results.pdf.byId[pdfHash])) {
        let newResult = false

        if (this.results && this.results.pdfs && this.results.pdfs.byId[pdfHash]) {
          newResult = this.results.pdfs.byId[pdfHash]
        } else if (this.results && this.results.pdfPdfs && this.results.pdfPdfs.byId[pdfHash]) {
          // TODO: This is not working, its never found for some reason...
          // Upper one works sometimes when actual search results (datasets) are same as datasetDatasets (coming from search, not F5)
          newResult = this.results.pdfPdfs.byId[pdfHash]
        }

        if (newResult !== false) {
          let normalizedResults = this.$store.getters['search/getResults']

          normalizedResults.pdf = {
            'byId': { [pdfHash]: this.results.pdfs.byId[pdfHash] },
            'allIds': [pdfHash]
          }

          this.$store.dispatch('search/setResults', normalizedResults)
        } else {
          await this.$store.dispatch('search/fetchPDF', pdfId)
        }
      }

      this.loaded = true
      let result = this.results.pdf.byId[pdfHash]
      // SEO Title and description
      document.title = result.attributes.title;
      /*if (result.attributes.description && result.attributes.description !== '') {
        document.querySelector('meta[name="description"]').setAttribute("content", result.attributes.description);
      } else*/ if (result.attributes.topics && result.attributes.topics.length > 0) {
        document.querySelector('meta[name="description"]').setAttribute("content", 'Gain market insights about ' + result.attributes.topics[0].attributes.name);
      }

      this.url.pdfDatasets = 'topics=' + result.attributes.topics[0].id + '&locations=' + result.attributes.locations[0].id + '&'
      this.url.pdfPdfs = 'topics=' + result.attributes.topics[0].id + '&locations=' + result.attributes.locations[0].id + '&'

      this.search('pdfDatasets', 'datasets', 'datasets?' + this.url.pdfDatasets)
      this.search('pdfPdfs', 'pdfs', 'pdfs?' + this.url.pdfPdfs)
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },
    ...helperMethods
  },
  watch: {
    $route (to, from) {
      this.loaded = false
      this.comingFrom = from.name
      this.resetResults()
      this.init()
    }
    /*isAuthenticated: function (per, current) {
      let response = this.$store.dispatch('search/fetchResults')
      if (response) {
        let that = this
        this.$nextTick(function () {
          that.refreshKey = '_' + Math.random().toString(36).substr(2, 9)
        })
      }
    }*/
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.comingFrom = from.name
    })
  },
  mounted () {
    this.resetResults()
    this.init()

    let that = this
    document.addEventListener('keyup', function (event) {
      if (event.keyCode === 27) {
        that.close()
      }
    })

    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy () {
    window.removeEventListener('keyup', this.nextItem)
    window.removeEventListener('resize', this.nextItem)
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.wrap {
  width: 100%;
  max-width: $xlContentWidth;
  height: auto;
  margin: 144px auto 64px auto;

  @media screen and (min-width: $breakpointSm) {
    width: calc(100% - 32px);
    margin: 100px auto 464px auto;
  }

  @media screen and (min-width: $breakpointLg) {
    margin: 108px auto 464px auto;
  }

  &--loading {
    height: 100vh;
  }
}

.pdf {
  @include font('content--md', $white, 0.9);
  width: calc(100% - 2px);
  border-width: 1px 1px 0 1px;
  border-style: solid;
  border-color: $black;
  background-color: $bg-4;
  box-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  position: relative;
  //padding-bottom: 3rem;

  @media screen and (min-width: $breakpointLg) {
    @include font('content--lg');
  }

  &__metadata {
    //background-color: $bg-4;
    //padding: 16px;
    //position: relative;
    white-space: pre-wrap;
    //border-top: 1px solid $black;
    //border-bottom: 1px solid $black;
  }

  &__meta {
    width: 100%;
    //white-space: pre-wrap;
    //height: auto;
  }

  &__content {
    position: relative;
    z-index: 20;
    border-top: 1px solid rgba($white, 0.1);
    border-bottom: 1px solid $black;
    background-color: $bg-4;
  }

  &__download {
    background-color: $bg-2;
    //box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    width: calc(100% - 2rem - 18px);
    max-width: 480px;
    margin: 2rem auto;
    padding: 1.5rem 1rem 2rem 1rem;
    border-radius: 4px;
    border: 1px solid $black;
    text-align: center;

    @media screen and (min-width: $breakpointLg) {
      max-width: 520px;
    }

    p {
      margin: 0 1rem 1.5rem 1rem;
      color: rgba($white, 0.7);
    }
  }

  &__panel {
    overflow: auto;
    position: absolute;
    top: 0px;
    z-index: 90;
    width: 100%;
    max-width: 540px;

    @media screen and (min-width: 540px) {
      //top: 16px;
      left: calc(50% - 270px);
    }

    &--success {
      overflow: visible;
    }
  }
}

.info {
  display: flex;
  flex-direction: column;
  margin: 0.75rem 0;

  &__item {
    display: flex;
    align-items: center;
    margin: 0.3rem 0;
  }

  &__icon {
    width: 18px;
    height: 18px;
    margin-right: 18px;
    fill: rgba($white, 0.5);

    @media screen and (min-width: $breakpointLg) {
      width: 20px;
      height: 20px;
    }

    &--blue {
      fill: $blue;
    }

    &--green {
      fill: $green;
    }

    &--yellow {
      fill: $yellow;
    }

    &--orange {
      fill: $orange;
    }

    &--pink {
      fill: $pink;
    }

    &--white {
      fill: rgba($white, 0.8);
    }
  }

  &__title {
    color: rgba($white, 0.7);
    width: 120px;
  }
}

.brief {
  position: absolute;
  z-index: 99;
  width: 100%;

  &--transition {
    &-enter-active, &-leave-active {
      transition: opacity 0.1s ease-in-out 1.2s, transform 0.4s cubic-bezier(0.0, 0.0, 0.3, 1.0) 1.2s;
    }
    &-enter, &-leave-to {
      opacity: 0;
      transform: translateY(-64px);
    }
  }

  &__wrap {
    width: 90%;
    max-width: 640px;
    margin: 4rem auto 0 auto;
    border-radius: 8px;
    padding: 1rem 1rem 1rem 0;
    background-color: $bg-3;
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  }

  /*p {
    @include font('content--md', $white);
    padding-right: 1rem;
    padding-left: 1rem;
    text-transform: uppercase;
    text-align: left;
  }*/

  &__items {
    margin: 0.5rem 1rem;
    padding-top: 1rem;
    border-top: 1px solid $bg-2;
    text-align: left;
  }

  &__item {
    display: flex;
    align-items: center;
    justify-items: center;
    justify-content: left;
    padding: 0.25rem 0;

    &--notice {
      margin-top: 1rem;
      padding-top: 0.5rem;
      border-top: 1px solid $bg-2;
    }

    &--check {
      .brief__item--icon {
        fill: $green;
      }
    }

    &--icon {
      //align-self: start;
      width: 1.25rem;
      min-width: 1.25rem;
      height: 1.25rem;
      min-height: 1.25rem;
      margin-right: 0.75rem;
      fill: rgba($white, 0.7);
    }

    &--text {
      @include font('content--md', $white);
    }

    &--light {
      @include font('content--md', $white, 0.7);
    }
  }
}

</style>
